document.addEventListener("DOMContentLoaded", function () {
    // Select all toggle headers
    if (window.innerWidth > 767) return;

    const headers = document.querySelectorAll(".v-stack.gap-4.sm\\:gap-5 p");
    
    headers.forEach(header => {
        const icon = document.createElement("span");
        icon.textContent = " +";
        icon.style.marginLeft = "8px";
        header.appendChild(icon);

        const ul = header.nextElementSibling;
        if (ul && ul.tagName === "UL") {
            ul.style.maxHeight = "0";
            ul.style.overflow = "hidden";
            ul.style.transition = "max-height 0.3s ease-out, padding 0.3s ease-out";
            ul.style.paddingTop = "0";
            ul.style.marginBottom = "0";
        }

        header.addEventListener("click", function () {
            if (!ul || ul.tagName !== "UL") return;
            
            if (ul.style.maxHeight === "0px" || ul.style.maxHeight === "0") {
                ul.style.maxHeight = ul.scrollHeight + "px";
                ul.style.paddingTop = "8px";
                ul.style.marginBottom = "20px";
                icon.textContent = " -";
            } else {
                ul.style.maxHeight = "0";
                ul.style.paddingTop = "0";
                ul.style.marginBottom = "0";
                icon.textContent = " +";
            }
        });
    });
});

